<!-- addition-requests -->
<div *ngIf="requestType == 'pending'">
    <div *ngIf="showFlag" [class]="editFlag ? 'card edit':'card'" class="pending-card-container">
        <div class="left-section">
            <div class="student-holder">
                <div class="request-date-wrapper">
                    <div class="requested-by">
                        {{'user-management.pending-requests.addition-request'| translate}}
                    </div>
                </div>
                <div class="student-wrapper">
                    <!-- student Info -->
                    <div class="student-info-wrapper">
                        <!-- student image -->
                        <div *ngIf="!compactView" class="image-cell"><img class="profile-img"
                                [src]="getImage(request.image_path)">
                        </div>
                        <!-- student name and national id -->
                        <div class="info-wrapper">
                            <!-- student name  -->
                            <div class="bold-name">{{request.name}}</div>
                            <!-- <div class="student-name" *ngIf="!editFlag">{{request.name}}</div> -->
                            <!-- <input (keyup)="checkName()" type="text"
                        [class]="foundError === null ?  'input-field error' : 'input-field'" *ngIf="editFlag"
                        [(ngModel)]="name">
                    <svg *ngIf="editFlag" class="edit-input" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Group" x="0px" y="0px"
                        viewBox="0 0 16 14" style="enable-background:new 0 0 16 14;" xml:space="preserve">
                        <style type="text/css">
                            .st0 {
                                fill: #707070;
                            }
                        </style>
                        <g>
                            <path class="st0"
                                d="M15.4,13H0.6C0.3,13,0,13.2,0,13.5C0,13.8,0.3,14,0.6,14h14.9c0.3,0,0.5-0.2,0.6-0.5C16,13.2,15.7,13,15.4,13z   " />
                            <path class="st0"
                                d="M0.5,11.7l2.4,0c0.1,0,0.3-0.1,0.4-0.1l8.2-8.2c0.2-0.2,0.2-0.5,0-0.7L9.1,0.1C8.9,0,8.6,0,8.4,0.1L6.8,1.8   L0.2,8.4C0.1,8.5,0,8.6,0,8.7l0,2.4c0,0.1,0.1,0.3,0.1,0.4C0.2,11.6,0.4,11.7,0.5,11.7z M8.8,1.2l1.7,1.7L9.5,3.8L7.8,2.2L8.8,1.2z    M1,9l6.1-6.1l1.7,1.7l-6.1,6.1l-1.7,0L1,9z" />
                        </g>
                    </svg> -->
                            <!-- student national id -->
                            <div class="small-name">{{'user-management.pending-requests.national-id'| translate}} :
                                <span data-pii="redact">{{request.national_id}}</span></div>
                        </div>
                    </div>
                    <!-- grade and class -->
                    <div class="grade-class-error-wrapper">
                        <div class="grade-class-wrapper">
                        <!-- grade -->
                        <div class="grade-wrapper">
                            <div class="bold-name">
                                {{'user-management.pending-requests.grade'| translate}}
                            </div>
                            <div class="grade-name">
                                <div class="small-name" *ngIf="!editFlag">{{request?.request_type ==
                                    "change_school_request" ?
                                    request.change_school_requests[0]?.to_class?.grade?.name :
                                    request.class?.grade?.name}}
                                </div>
                                <select [(ngModel)]="gradeId" (change)="getClassList(true)" class="input-field"
                                    *ngIf="editFlag">
                                    <option [value]="grade.id" [attr.selected]="gradeId==grade.id"
                                        *ngFor="let grade of grades">
                                        {{grade.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <!-- class -->
                        <div class="class-wrapper">
                            <div class="bold-name">
                                {{'user-management.pending-requests.class'| translate}}
                            </div>
                            <div class="class-name">
                                <div class="small-name" *ngIf="!editFlag">{{request?.request_type ==
                                    "change_school_request" ?
                                    request.change_school_requests[0]?.to_class?.name : request.class?.name}}</div>
                                <select [(ngModel)]="classId" class="mdb-select md-form" class="input-field"
                                    *ngIf="editFlag">
                                    <option [value]="clazz.id" [attr.selected]="classId==clazz.id"
                                        *ngFor="let clazz of classList">
                                        {{clazz.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <!-- icons -->
                        <div class="icons-wrapper ">
                            <!-- edit icon -->
                            <div *ngIf="request.request_type != 'change_school_request'"
                                matTooltip="{{'user-management.pending-requests.edit'| translate}}">
                                <svg *ngIf="!editFlag" (click)="editStudent()" class="edit"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    version="1.1" id="Group" x="0px" y="0px" viewBox="0 0 16 14"
                                    style="enable-background:new 0 0 16 14;" xml:space="preserve" [appGuardCtaByPermission]="'editInfoNewAdditions'">
                                    <style type="text/css">
                                        .st0 {
                                            fill: #707070;
                                        }
                                    </style>
                                    <g>
                                        <path class="st0"
                                            d="M15.4,13H0.6C0.3,13,0,13.2,0,13.5C0,13.8,0.3,14,0.6,14h14.9c0.3,0,0.5-0.2,0.6-0.5C16,13.2,15.7,13,15.4,13z   " />
                                        <path class="st0"
                                            d="M0.5,11.7l2.4,0c0.1,0,0.3-0.1,0.4-0.1l8.2-8.2c0.2-0.2,0.2-0.5,0-0.7L9.1,0.1C8.9,0,8.6,0,8.4,0.1L6.8,1.8   L0.2,8.4C0.1,8.5,0,8.6,0,8.7l0,2.4c0,0.1,0.1,0.3,0.1,0.4C0.2,11.6,0.4,11.7,0.5,11.7z M8.8,1.2l1.7,1.7L9.5,3.8L7.8,2.2L8.8,1.2z    M1,9l6.1-6.1l1.7,1.7l-6.1,6.1l-1.7,0L1,9z" />
                                    </g>
                                </svg>
                            </div>

                            <!-- save edit -->
                            <div matTooltip="{{'user-management.pending-requests.submit'| translate}}">
                                <svg *ngIf="editFlag" (click)="saveStudent(request)" [ngClass]="classId ? 'accept':'dimmed'"
                                    [class.disabled]="!classId" version="1.1" id="Layer_1"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px" y="0px" viewBox="0 0 16 12.7" style="enable-background:new 0 0 16 12.7;"
                                    xml:space="preserve">
                                    <style type="text/css">
                                        .st0 {
                                            fill: #707070;
                                        }
                                    </style>
                                    <g id="Group_5269" transform="translate(-10692 2203.707)">
                                        <g id="Path_1390">
                                            <path class="st0" d="M10707.4-2192h-14.9c-0.3,0-0.5,0.2-0.6,0.5c0,0.3,0.3,0.5,0.6,0.5h14.9c0.3,0,0.5-0.2,0.6-0.5
                            C10708-2191.8,10707.7-2192,10707.4-2192z" />
                                        </g>
                                        <g id="Path_5441">
                                            <path class="st0" d="M10697.6-2195.2l-3.4-3.4c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l2.7,2.7l6.7-6.7c0.2-0.2,0.5-0.2,0.7,0
                            s0.2,0.5,0,0.7L10697.6-2195.2z" />
                                        </g>
                                    </g>
                                </svg>
                            </div>

                            <!-- cancel edit  -->
                            <div matTooltip="{{'user-management.pending-requests.cancel'| translate}}">
                                <svg *ngIf="editFlag" (click)="cancelEdit()" class="cancel"
                                    xmlns="http://www.w3.org/2000/svg" width="10.467" height="10.467"
                                    viewBox="0 0 15.467 15.467">
                                    <defs>
                                        <style>
                                            .cls-1 {
                                                fill: none;
                                                stroke: #f46363;
                                                stroke-linecap: round;
                                                stroke-width: 2px;
                                            }
                                        </style>
                                    </defs>
                                    <g id="Group_5139" data-name="Group 5139" transform="translate(1.414 1.414)">
                                        <path id="Path_5450" data-name="Path 5450" class="cls-1"
                                            d="M11350.7-4054.514l12.639,12.639"
                                            transform="translate(-11350.703 4054.514)" />
                                        <path id="Path_5451" data-name="Path 5451" class="cls-1"
                                            d="M11350.7-4041.856l12.566-12.567"
                                            transform="translate(-11350.703 4054.495)" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                        </div>
                        <div *ngIf="editFlag && !classId" class="fill-class-error">
                            {{'user-management.pending-requests.fill-error'| translate}}
                        </div>
                    </div> 
                </div>
            </div>
        </div>
        <div class="right-section" [class.disabled]="editFlag"
            [ngClass]="(currLang == 'en') ? 'devider' : 'devider-ar'">
            <!-- case of add student pending requests -->
            <div class="parent-holder" *ngIf="request.request_type == 'parent_request'">
                <div class="parent-wrapper" *ngFor="let parent of request.related_pending_parents">
                    <div class="request-date-wrapper">
                        <div class="requested-by">
                            {{'user-management.pending-requests.requested-by'| translate}}
                        </div>
                        <div class="created_at-wrapper">
                            <img src="../../../../assets/icons/requests/pending/dateTimeIcon.svg" alt="date time icon">
                            <div class="created_at">
                                &nbsp;
                                &nbsp;{{(parent.pivot.created_at || request.created_at) |
                                timeZone:'':currLang:'YYYY-MM-DD HH:mm:ss':'':true:true:false}}
                            </div>
                        </div>
                    </div>
                    <div class="info-actions-container">
                        <!-- parent Info -->
                        <div class="parent-info-wrapper">
                            <!-- parent image -->
                            <div *ngIf="!compactView" class="image-cell"
                                [ngStyle]="{'text-align' : currLang == 'en' ? 'left' : 'center'}"><img
                                    class="profile-img" [src]="getImage(parent.image_path)">
                            </div>
                            <!-- parent name , national id and phone -->
                            <div class="info-wrapper">
                                <!-- parent name  -->
                                <div class="bold-name">{{parent.name}}</div>
                                <!-- parent national id -->
                                <div class="small-name">{{'user-management.pending-requests.national-id'| translate}} :
                                    <span data-pii="redact">{{parent.national_id}}</span>
                                </div>
                                <!-- parent phone number -->
                                <div class="small-name">{{'user-management.pending-requests.phone'| translate}} :
                                    <div class="phone-number" data-pii="redact">
                                        {{parent?.phone_number}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- approve or decline actions -->
                        <div class="actions-wrapper">
                            <!-- decline request -->
                            <div matTooltip="{{'user-management.pending-requests.decline'| translate}}">
                                <svg (click)="takeAction(false, parent.id,requestType,request)" [ngClass]="editFlag ? 'dimmed' : 'reject'"
                                    xmlns="http://www.w3.org/2000/svg" width="10.467" height="10.467"
                                    viewBox="0 0 15.467 15.467"  [appGuardCtaByPermission]="'RejectNewAdditions'">
                                    <g id="Group_5139" data-name="Group 5139" transform="translate(1.414 1.414)">
                                        <path id="Path_5450" data-name="Path 5450" class="cls-1"
                                            d="M11350.7-4054.514l12.639,12.639"
                                            transform="translate(-11350.703 4054.514)" />
                                        <path id="Path_5451" data-name="Path 5451" class="cls-1"
                                            d="M11350.7-4041.856l12.566-12.567"
                                            transform="translate(-11350.703 4054.495)" />
                                    </g>
                                </svg>
                            </div>

                            <div [ngClass]="(currLang == 'en') ? 'action-devider' : 'action-devider-ar'">
                            </div>
                            <!-- approve request -->
                            <div matTooltip="{{'user-management.pending-requests.approve'| translate}}">
                                <svg (click)="takeAction(true, parent.id,requestType,request)" [ngClass]="editFlag ? 'dimmed' : 'accept'"
                                    xmlns="http://www.w3.org/2000/svg" width="15.79" height="15.215"
                                    viewBox="0 0 20.79 16.215" [appGuardCtaByPermission]="'AcceptNewAdditions'">
                                    <path id="Path_5449" data-name="Path 5449" class="cls-1"
                                        d="M11030.926-4621.432l4.807,4.428,13.156-13.409"
                                        transform="translate(-11029.513 4631.827)" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- case of transfer student to another school request -->
            <div class="parent-holder" *ngIf="request.request_type == 'change_school_request'">
                <div class="parent-wrapper" *ngFor="let changeRequest of request.change_school_requests">
                        <div class="request-date-wrapper">
                        <div class="requested-by">
                            {{'user-management.pending-requests.requested-by'| translate}}
                        </div>
                        <div class="created_at-wrapper">
                            <img src="../../../../assets/icons/requests/pending/dateTimeIcon.svg" alt="date time icon">
                            <div class="created_at">
                                &nbsp;
                                &nbsp;{{(changeRequest?.created_at) | timeZone:'':currLang:'YYYY-MM-DD HH:mm:ss':'':true:true:false}}
                            </div>
                        </div>
                    </div>
                    <div class="info-actions-container">
                        <!-- parent Info -->
                        <div class="parent-info-wrapper">
                            <!-- parent image -->
                            <div *ngIf="!compactView" class="image-cell"
                                [ngStyle]="{'text-align' : currLang == 'en' ? 'left' : 'center'}"><img
                                    class="profile-img" [src]="getImage(changeRequest?.requester?.image_path)">
                            </div>
                            <!-- parent name , national id and phone -->
                            <div class="info-wrapper">
                                <!-- parent name  -->
                                <div class="bold-name">{{changeRequest?.requester?.name}}</div>
                                <!-- parent national id -->
                                <div class="small-name">{{'user-management.pending-requests.national-id'| translate}} :
                                    <span data-pii="redact">{{changeRequest?.requester?.national_id}}</span>
                                </div>
                                <!-- parent phone number -->
                                <div class="small-name">{{'user-management.pending-requests.phone'| translate}} :
                                    <div class="phone-number" data-pii="redact">
                                        {{changeRequest?.requester?.phone_number}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- approve or decline actions -->
                        <div class="actions-wrapper">
                            <!-- decline request -->
                            <div matTooltip="{{'user-management.pending-requests.decline'| translate}}">
                                <svg (click)="takeAction(false, changeRequest?.requester?.id,requestType,request)"
                                    class="reject" xmlns="http://www.w3.org/2000/svg" width="10.467" height="10.467"
                                    viewBox="0 0 15.467 15.467" [appGuardCtaByPermission]="'RejectNewAdditions'">
                                    <defs>
                                        <style>
                                            .cls-1 {
                                                fill: none;
                                                stroke: #707070;
                                                stroke-linecap: round;
                                                stroke-width: 2px;
                                            }
                                        </style>
                                    </defs>
                                    <g id="Group_5139" data-name="Group 5139" transform="translate(1.414 1.414)">
                                        <path id="Path_5450" data-name="Path 5450" class="cls-1"
                                            d="M11350.7-4054.514l12.639,12.639"
                                            transform="translate(-11350.703 4054.514)" />
                                        <path id="Path_5451" data-name="Path 5451" class="cls-1"
                                            d="M11350.7-4041.856l12.566-12.567"
                                            transform="translate(-11350.703 4054.495)" />
                                    </g>
                                </svg>
                            </div>

                            <div [ngClass]="(currLang == 'en') ? 'action-devider' : 'action-devider-ar'">
                            </div>
                            <!-- approve request -->
                            <div matTooltip="{{'user-management.pending-requests.approve'| translate}}">
                                <svg [class.active]="request.class && request.class.grade"
                                    (click)="takeAction(true, changeRequest?.requester?.id,requestType,request)"
                                    class="accept" xmlns="http://www.w3.org/2000/svg" width="15.79" height="15.215"
                                    viewBox="0 0 20.79 16.215" [appGuardCtaByPermission]="'AcceptNewAdditions'">
                                    <defs>
                                        <style>
                                            .cls-1 {
                                                fill: none;
                                                stroke: #707070;
                                                stroke-linecap: round;
                                                stroke-width: 2px;
                                            }
                                        </style>
                                    </defs>
                                    <path id="Path_5449" data-name="Path 5449" class="cls-1"
                                        d="M11030.926-4621.432l4.807,4.428,13.156-13.409"
                                        transform="translate(-11029.513 4631.827)" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- edit-requests -->
<div class="edit-requests-wrapper" *ngIf="requestType == 'edit'">
    <div class="edit-card">
        <div class="date-wrapper">
            <div class="edit-request-time">
                &nbsp;
                &nbsp;<span *ngIf="request?.created_at">{{(request.created_at) |
                    timeZone:'':currLang:'YYYY-MM-DDTHH:mm:ss.SSSSSSZ':'':true:true:false}}</span>
            </div>
        </div>
        <div class="request-content">
            <div class="left-section">
                <div class="info-wrapper">
                    <!-- [src]="getImage(request.image_path) -->
                    <img class="profile-img" [src]="baseuUlr+request?.parent?.image_path">
                    <div class="info">
                        <span class="student-name">{{request?.parent?.name}}</span>
                        <span class="student-id"> {{'user-management.pending-requests.national-id'| translate}} :
                            <span data-pii="redact">{{request?.parent?.national_id}}</span></span>
                    </div>
                </div>
                <div class="student-info-wrapper">
                    <div class="info">
                        <span class="student-name-wrapper">{{'user-management.pending-requests.student-name'|
                            translate}} :
                            <span triggers="manual" #t="ngbTooltip" placement="bottom" tooltipClass="my-custom-class"
                                [ngbTooltip]="infoTemplate" (mouseover)="t.open()" (mouseout)="t.close()">
                                <span class="studentName bold-name">{{request?.student?.name}}</span>
                            </span>
                        </span>
                        <span class="student-id"> {{'user-management.pending-requests.national-id'| translate}} :
                            <span data-pii="redact">{{request?.student?.national_id}}</span></span>
                    </div>
                </div>

                <ng-template #infoTemplate>
                    <div class="tooltip-container">
                        <div>{{request?.student?.name}}</div>
                    </div>
                </ng-template>
            </div>
            <div class="mid-section">
                <div class="request-body">
                    <span class="edit-desc">{{'user-management.edit-requests.change-request'| translate}}</span>
                    <table>
                        <tr *ngIf="request.old_values.hasOwnProperty('image')">
                            <td>
                                <img class="student-img" [src]="request?.old_values?.image">
                            </td>
                            <td class="td-indecator">
                                <div class="indicator"
                                    [ngClass]="currLang=='en'?'indicator-transform':'indicator-transform-rtl'">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </td>
                            <td>
                                <img class="student-img" [src]="request?.new_values?.image">
                            </td>
                        </tr>
                        <tr *ngIf="!!request.old_school_class">
                            <td>
                                {{request?.old_school_class?.grade?.name}}
                            </td>
                            <td class="td-indecator">
                                <div class="indicator"
                                    [ngClass]="currLang=='en'?'indicator-transform':'indicator-transform-rtl'">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </td>
                            <td class="to">
                                {{request?.new_school_class?.grade?.name}}
                            </td>
                        </tr>
                        <tr *ngIf="!!request.old_school_class">
                            <td>
                                {{request?.old_school_class?.name}}
                            </td>
                            <td class="td-indecator">
                                <div class="indicator"
                                    [ngClass]="currLang=='en'?'indicator-transform':'indicator-transform-rtl'">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </td>
                            <td class="to">
                                {{request?.new_school_class?.name}}
                            </td>
                        </tr>
                        <tr *ngIf="request.old_values.hasOwnProperty('name')">
                            <td>
                                {{request?.old_values?.name}}
                            </td>
                            <td class="td-indecator">
                                <div class="indicator"
                                    [ngClass]="currLang=='en'?'indicator-transform':'indicator-transform-rtl'">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </td>
                            <td class="to">
                                {{request?.new_values?.name}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="right-section">
                <div class="actions">
                    <!-- edit -->
                    <span>
                        <svg (click)="takeAction('edit', request.id,requestType,request)" width="40" height="40"
                            viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M25.8791 21.9393C25.8311 21.938 25.7833 21.9462 25.7385 21.9634C25.6936 21.9806 25.6527 22.0065 25.6178 22.0396C25.583 22.0726 25.555 22.1122 25.5355 22.1561C25.516 22.1999 25.5053 22.2472 25.5041 22.2952V25.4616C25.4962 25.7521 25.3736 26.0278 25.163 26.2281C24.9524 26.4285 24.671 26.5373 24.3804 26.5307H13.8723C13.5817 26.5373 13.3003 26.4285 13.0897 26.2281C12.8791 26.0278 12.7565 25.7521 12.7486 25.4616V16.1711C12.7565 15.8806 12.8791 15.6049 13.0897 15.4046C13.3003 15.2042 13.5817 15.0954 13.8723 15.102H17.1982C17.2469 15.1051 17.2956 15.0981 17.3415 15.0815C17.3874 15.065 17.4294 15.0392 17.4649 15.0058C17.5005 14.9724 17.5288 14.932 17.5482 14.8873C17.5675 14.8425 17.5775 14.7942 17.5775 14.7455C17.5775 14.6967 17.5675 14.6484 17.5482 14.6037C17.5288 14.5589 17.5005 14.5185 17.4649 14.4851C17.4294 14.4517 17.3874 14.426 17.3415 14.4094C17.2956 14.3928 17.2469 14.3859 17.1982 14.3889H13.8723C13.3879 14.3779 12.9189 14.5593 12.568 14.8933C12.2171 15.2273 12.0129 15.6868 12 16.1711V25.4629C12.0132 25.947 12.2176 26.4061 12.5685 26.7399C12.9194 27.0736 13.3881 27.2548 13.8723 27.2438H24.3804C24.8648 27.2548 25.3338 27.0735 25.6847 26.7394C26.0356 26.4054 26.2398 25.9459 26.2527 25.4616V22.2966C26.2516 22.2486 26.2411 22.2013 26.2218 22.1573C26.2024 22.1134 26.1746 22.0737 26.1399 22.0405C26.1052 22.0074 26.0643 21.9813 26.0196 21.964C25.9748 21.9466 25.9271 21.9382 25.8791 21.9393V21.9393Z"
                                fill="#C3C3C3" stroke="#C3C3C3" stroke-width="0.7" />
                            <path
                                d="M26.1111 13.4697C25.8101 13.169 25.402 13 24.9765 13C24.5511 13 24.143 13.169 23.842 13.4697L17.4806 19.8311C17.4372 19.8746 17.4057 19.9286 17.3893 19.9879L16.5534 23.0084C16.5362 23.0692 16.5356 23.1336 16.5516 23.1948C16.5676 23.256 16.5996 23.3118 16.6443 23.3565C16.689 23.4013 16.7448 23.4333 16.806 23.4492C16.8672 23.4652 16.9316 23.4646 16.9925 23.4474L20.0129 22.6102C20.0722 22.5938 20.1262 22.5623 20.1697 22.5188L26.5311 16.1575C26.8315 15.8563 27.0003 15.4483 27.0003 15.0229C27.0003 14.5975 26.8315 14.1895 26.5311 13.8884L26.1111 13.4697ZM18.2579 20.0629L23.4643 14.8565L25.1443 16.5365L19.9379 21.7429L18.2579 20.0629ZM17.9225 20.7365L19.2643 22.0784L17.4084 22.5924L17.9225 20.7365ZM26.0252 15.6543L25.6475 16.032L23.9688 14.3534L24.3466 13.9756C24.5137 13.8088 24.7403 13.715 24.9765 13.715C25.2128 13.715 25.4393 13.8088 25.6065 13.9756L26.0252 14.3943C26.1917 14.5617 26.2852 14.7882 26.2852 15.0243C26.2852 15.2604 26.1917 15.4869 26.0252 15.6543V15.6543Z"
                                fill="#C3C3C3" stroke="#C3C3C3" stroke-width="0.7" />
                            <circle cx="20" cy="20" r="19.5" stroke="#C3C3C3" />
                        </svg>

                    </span>
                    <!-- devider -->
                    <span>
                        <svg width="2" height="35" viewBox="0 0 2 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.42" d="M0.718262 0.666626V34" stroke="#707070" stroke-linecap="round" />
                        </svg>
                    </span>
                    <!-- cancel -->
                    <span>
                        <svg (click)="takeAction(false, request.id,requestType,request)" width="40" height="40"
                            viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="19.5" stroke="#C3C3C3" />
                            <path d="M14.6667 14.6666L25.8142 25.8143" stroke="#C3C3C3" stroke-linecap="round" />
                            <path d="M14.6667 25.8144L25.7496 14.73" stroke="#C3C3C3" stroke-linecap="round" />
                        </svg>

                    </span>
                    <!-- devider -->
                    <span>
                        <svg width="2" height="35" viewBox="0 0 2 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.42" d="M0.718262 0.666626V34" stroke="#707070" stroke-linecap="round" />
                        </svg>
                    </span>
                    <!-- submit -->
                    <span>
                        <svg (click)="takeAction(true, request.id,requestType,request)" width="40" height="40"
                            viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#50D0A7" />
                            <path d="M10.6667 21.8232L15.6627 26.6667L29.3334 12" stroke="white" stroke-width="2"
                                stroke-linecap="round" />
                        </svg>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- early-dismissal-requests -->
<div class="edit-requests-wrapper" *ngIf="requestType == 'early-dismissal'">
    <div class="early-dismissal-card">
        <div class="date-wrapper">
            <div class="lables-wrapper">
                <span class="status-label"
                [ngClass]="{
                    'status-pending': request?.status === 'pending',
                    'status-parent-arrived': request?.status === 'parent_arrived',
                    'status-approved': request?.status === 'approved',
                    'status-declined': request?.status === 'declined',
                    'status-cancelled': request?.status === 'canceled',
                    'status-delivered': request?.status === 'delivered'
                }">
                {{ ('user-management.early-dismissal-requests.status.' + request?.status) | translate }}
                </span>
                <div *ngIf="request?.status === 'pending'" class="status-label approved-requests d-flex">
                    <svg xmlns="http://www.w3.org/2000/svg"
                    width="12" height="14" viewBox="0 0 12 14"
                    fill="none" stroke="#475467" stroke-width="1"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4.775,12.6H1.975C1.202,12.6 0.575,11.973 0.575,11.2L0.575,2.8C0.575,2.027 1.202,1.4 1.975,1.4H8.275C9.048,1.4 9.675,2.027 9.675,2.8V6.65M6.875,10.617L8.158,11.9L11.425,8.4"
                    fill="none"/>
                    </svg>
                    <span>{{'user-management.early-dismissal-requests.approved-requests'| translate}} : {{request?.approved_requests_count | arabicNumber:currLang}}</span>
            </div>
            </div>
            <div class="edit-request-time">
                {{request?.created_at | timeDifference: currLang : false}}
            </div>
        </div>
        <div class="request-content">
            <div class="left-section">
                <div class="student-requestee-info-container">
                    <div class="student-requestee-wrapper">
                        <div class="student-info-wrapper">
                            <img class="profile-img" [src]="baseuUlr+request?.student?.image_path">
                            <div class="student-info">
                                <div class="student-name">
                                    {{request?.student?.name}}
                                </div>
                                <div class="student-national-id">
                                    {{request?.student?.class?.grade?.name}} | {{request?.student?.class?.name}}
                                </div>
                                <div class="student-national-id">
                                    <span>{{'user-management.early-dismissal-requests.id-number'| translate}} : </span>
                                    <span data-pii="redact">{{request?.student?.national_id}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="requestee-info-wrapper">
                            <div class="title-value-wrapper">
                                <div class="title">{{'user-management.early-dismissal-requests.requested-by'|
                                    translate}} :
                                </div>
                                <div class="value parent-name">{{request?.requester?.name}}</div>
                            </div>
                            <div class="title-value-wrapper">
                                <div class="title">{{'user-management.early-dismissal-requests.requestee-contact-info'|
                                    translate}} : </div>
                                <div class="value" dir="ltr" data-pii="redact">{{request?.requester?.phone_number}}</div>
                            </div>
                            <div class="title-value-wrapper">
                                <div class="title">{{'user-management.early-dismissal-requests.request-estimate-time'|
                                    translate}} : </div>
                                <div class="value">{{request?.estimated_pickup_time |
                                    timeZone:request?.created_at:currLang:'YYYY-MM-DD HH:mm:ss':'hh:mm A':true:false:true}}
                                </div>
                            </div>
                            <ng-template #requesterInfoTemplate>
                                <div class="tooltip-container">
                                    <div>{{request?.requester?.name}}</div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mid-section">
                <div class="request-body">
                    <div class="request-reason-title">
                        <span *ngIf="request?.status != 'declined'">{{'user-management.early-dismissal-requests.request-reason'| translate}}</span>
                        <span  *ngIf="request?.status === 'declined'">{{'user-management.early-dismissal-requests.decline-reason-title'| translate}}</span>
                    </div>
                    <div class="request-reason">
                        {{request?.status === 'declined' ? request?.rejection_reason : request?.reason}}
                    </div>
                </div>
            </div>
            <div class="right-section">
                <div class="actions" *ngIf="request?.status == 'pending'">
                    <!-- cancel -->
                    <span>
                        <svg (click)="takeAction(false, request?.id,requestType,request)" width="40" height="40"
                            viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="19.5" stroke="#C3C3C3" />
                            <path d="M14.6667 14.6666L25.8142 25.8143" stroke="#C3C3C3" stroke-linecap="round" />
                            <path d="M14.6667 25.8144L25.7496 14.73" stroke="#C3C3C3" stroke-linecap="round" />
                        </svg>

                    </span>
                    <!-- devider -->
                    <span>
                        <svg width="2" height="35" viewBox="0 0 2 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.42" d="M0.718262 0.666626V34" stroke="#707070" stroke-linecap="round" />
                        </svg>
                    </span>
                    <!-- submit -->
                    <span>
                        <svg (click)="takeAction(true, request?.id,requestType,request)" width="40" height="40"
                            viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="20" cy="20" r="20" fill="#50D0A7" />
                            <path d="M10.6667 21.8232L15.6627 26.6667L29.3334 12" stroke="white" stroke-width="2"
                                stroke-linecap="round" />
                        </svg>
                    </span>
                </div>
                <div class="action-deliver" *ngIf="request?.status == 'parent_arrived'">
                    <button class="btn btn-primary deliver-btn" (click)="deliverEarlyDismissalRequestStudent(request.id,requestType,request)">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="white"/>
                        </svg>
                        {{'user-management.early-dismissal-requests.deliver'| translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<app-error-msg></app-error-msg>